<template>
<base-nav container-classes="container-fluid" class="navbar-top navbar-expand" :class="{'navbar-dark': type === 'default'}">
    <!-- <a href="#" aria-current="page" class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active"> {{$route.name}} </a> -->
    <div class="curved-white">
    <img @click="redirectToHome" class="logo-img ml-4 mt-3 mb-1" src="img/brand/green.png">

    </div>
    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
        <!-- This item don't have <b-nav-item> because item have data-action/data-target on tag <a>, which we cant add -->
        <li class="nav-item d-sm-none">
            <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
                <i class="ni ni-zoom-split-in"></i>
            </a>
        </li>
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
     
        <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
            <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
                <b-media no-body class="align-items-center">
                  
                    <i class="fa-solid fa-arrow-right-from-bracket arrow-color "></i>
                    <b-media-body class="ml-2 d-none d-lg-block">
                        <span class="mb-0 text-sm text-white  font-weight-bold">{{user_name}}</span>
                    </b-media-body>
                </b-media>
            </a>

            <template>
              <div class="dropdown-arrangement">
                <b-dropdown-header class="noti-title">
                    <h6 class="text-overflow m-0">Welcome!</h6>
                </b-dropdown-header>
                <b-dropdown-item @click="redirectToHome">
                    <i class="fa-solid fa-home"></i>
                    <span>Home</span>
                </b-dropdown-item>
                <b-dropdown-item to="/resetpassword" href="#!">
                    <i class="fa-solid fa fa-key"></i>
                    <span>Reset Password</span>
                </b-dropdown-item>
                <b-dropdown-item @click="redirectToUserMgt" v-if="is_admin">
                    <i class="fa-solid fa-gear"></i>
                    <span>Settings</span>
                </b-dropdown-item>
                <div class="dropdown-divider"></div>
                <b-dropdown-item @click="logout()">
                    <i class="fa-solid fa-power-off"></i>
                    <span>Logout</span>
                </b-dropdown-item>
              </div>
            </template>
        </base-dropdown>
    </b-navbar-nav>
</base-nav>
</template>

<script>
import { mapState, mapActions , mapGetters } from "vuex";
import mixins from "./../../mixins/common.js";
import {
    CollapseTransition
} from 'vue2-transitions';
import {
    BaseNav,
    Modal
} from '@/components';

export default {
    components: {
        CollapseTransition,
        BaseNav,
        Modal
    },
    mixins: [mixins],
    props: {
        type: {
            type: String,
            default: 'default', // default|light
            description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
        }
    },
    computed: {
        ...mapState("user", ["user_name","is_admin"]),
        routeName() {
            const {
                name
            } = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    },
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchModalVisible: false,
            searchQuery: ''
        };
    },
    methods: {
        ...mapActions("user", ["destroyToken"]),
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        logout() {
           this.destroyToken();
        },
    },
    mounted(){
    }
};
</script>

<style scoped>
.logo-img {
    width: 80px;
    height: auto;
}
.dropdown-arrangement{
  z-index: 10000 !important;
}
.main-content .navbar-top {
    background-color: #921210;
}
.text-primary {
    color: #ffffff !important;
}
.curved-white{
    background-color: #ffffff;
    width: 125px;
    height: 65px;
  margin-top: -25px;
    margin-left: 0px;
    margin-bottom: -20px;
    display: flex;
  /* border-radius:0 100px 100px 0px; */
}
</style>
